import React from 'react';
import { siteConfig } from '../config/site';
import { Phone, MapPin, Clock, MessageCircle } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-28 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Header - Simple and direct */}
          <div className="mb-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
              Get in touch.
            </h1>
            <p className="text-lg text-slate-600">
              Questions about joining? Want to learn more? Here's how to reach us.
            </p>
          </div>

          {/* Main Contact Methods */}
          <div className="space-y-4 mb-12">

            {/* Phone */}
            <a 
              href={`tel:${siteConfig.contact.phone}`}
              className="relative flex items-center p-6 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors group overflow-hidden"
            >
              {/* Icon Imprint */}
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <Phone className="w-20 h-20 text-slate-200" />
              </div>
              <div className="relative z-10">
                <div className="text-sm text-slate-500 mb-0.5">Call or text</div>
                <div className="text-xl font-semibold text-slate-900 group-hover:text-navy-600 transition-colors">
                  {siteConfig.contact.phone}
                </div>
              </div>
            </a>

            {/* Location */}
            <div className="relative flex items-center p-6 bg-slate-50 rounded-xl overflow-hidden">
              {/* Icon Imprint */}
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <MapPin className="w-20 h-20 text-slate-200" />
              </div>
              <div className="relative z-10">
                <div className="text-sm text-slate-500 mb-0.5">Based in</div>
                <div className="text-xl font-semibold text-slate-900">
                  Los Angeles, CA
                </div>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="mb-12">
            <div className="flex items-center gap-2 mb-4">
              <Clock className="w-5 h-5 text-slate-400" />
              <h2 className="text-lg font-semibold text-slate-900">Hours</h2>
            </div>
            <div className="bg-slate-50 rounded-xl p-5">
              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-slate-600">Monday – Friday</span>
                  <span className="text-slate-900 font-medium">8am – 6pm PST</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Saturday</span>
                  <span className="text-slate-900 font-medium">9am – 2pm PST</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Sunday</span>
                  <span className="text-slate-400">Closed</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Note */}
          <div className="bg-navy-50 border border-navy-100 rounded-xl p-5">
            <div className="flex items-start gap-3">
              <MessageCircle className="w-5 h-5 text-navy-600 mt-0.5 flex-shrink-0" />
              <div>
                <div className="font-medium text-slate-900 mb-1">Fastest way to reach us?</div>
                <p className="text-sm text-slate-600">
                  Text us. We check texts more than email and usually respond within a few hours during business hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
